import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DataAccess } from '../../../data-access/services/data-access.service';

function passwordConfirmValidation(control: FormGroup): ValidationErrors | null {
  const password = control.get('password');
  const confirm = control.get('passwordConfirm');
  return password.value === confirm.value ? null : { dismatch: true };
}

@Component({
  selector: 'bm-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  changePasswordForm: FormGroup;
  token: string;
  email: string;
  errMsg: string;
  passVisibility: boolean;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private dataAccess: DataAccess) { }

  updatePassword() {
    const password = this.changePasswordForm.get('password').value;

    this.dataAccess.execute('UpdatePassword', {email: this.email, token: this.token, password})
    .then(({data}) => {
      alert(data[0][0].instruction);
    })
    .catch(err => {
      this.errMsg = err;
    });
  }

  ngOnInit() {
    this.token = this.activeRoute.snapshot.queryParamMap.get('token');
    this.email = this.activeRoute.snapshot.queryParamMap.get('email');

    this.changePasswordForm = this.fb.group({
      password: ['', Validators.required],
      passwordConfirm: ['', Validators.required],
    }, {validators: passwordConfirmValidation});

    this.dataAccess.execute('CheckValidResetPasswordCredentials', {email: this.email, token: this.token})
    .catch(err => {
      this.errMsg = err;
      this.changePasswordForm.disable();
    });
  }


}
